export default "__VITE_ASSET__0V_F4H4e__"